import { InputHTMLAttributes } from 'react';

export type ToggleSwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  checked: boolean;
  isDisabled?: boolean;
};

const ToggleSwitch = ({
  checked,
  onChange,
  isDisabled,
  disabled,
  className = '',
  ...rest
}: ToggleSwitchProps) => {
  const isInputDisabled = isDisabled ?? disabled;

  return (
    <label
      className={`relative inline-block h-6 w-11 shrink-0 ${
        isInputDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={isInputDisabled}
        className="peer absolute h-0 w-0 opacity-0"
        {...rest}
      />
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full border border-neutral-200 bg-[var(--system-50,#fff)] transition-colors peer-checked:border-[var(--primary-200,#177ba6)] peer-checked:bg-[var(--primary-200,#177ba6)] peer-disabled:border-neutral-200 peer-disabled:bg-neutral-50"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute left-0.5 top-0.5 h-5 w-5 rounded-full border border-neutral-200 bg-neutral-100 transition-transform peer-checked:translate-x-[1.625rem] peer-checked:border-white peer-checked:bg-white peer-disabled:border-neutral-200 peer-disabled:bg-neutral-50"
      />
    </label>
  );
};

export default ToggleSwitch;
